export interface TblDecInvProyectoTesistaCronograma {
    iddecinvproyectotesistacronograma: number;
    iddecinvproyecto: number;
    iddecinvproyectotesista: number;
    actividad: string;
    fechainicio: Date;
    fechafin: Date;
    resultados: string;
    porcentajeparcial1: number;
    porcentajeparcial2: number;
    archivoevidencia1: string;
    archivoevidencia2: string;
    fechaevidencia1: Date;
    fechaevidencia2: Date;
    presencial: number;
}

export function VoidTblDecInvProyectoTesistaCronograma(): TblDecInvProyectoTesistaCronograma {
    const fechaHoy = new Date();
    return (
        {
            iddecinvproyectotesistacronograma: 0,
            iddecinvproyecto: 0,
            iddecinvproyectotesista: 0,
            actividad: '',
            fechainicio: fechaHoy,
            fechafin: new Date(),
            resultados: '',
            porcentajeparcial1: 0,
            porcentajeparcial2: 0,
            archivoevidencia1: '',
            archivoevidencia2: '',
            fechaevidencia1: new Date(),
            fechaevidencia2: new Date(),
            presencial: 0,
        }
    )
}

//new Date(act.fechainicio).toISOString().slice(0, 10)
export function SetTblDecInvProyectoTesistaCronograma(data: any): TblDecInvProyectoTesistaCronograma {
    const fechaHoy = new Date();
    const inicio = new Date(data.fechainicio).toISOString().slice(0, 10)
    const fin = new Date(data.fechafin).toISOString().slice(0, 10)
    return (
        {
            iddecinvproyectotesistacronograma: data.iddecinvproyectotesistacronograma ?? 0,
            iddecinvproyecto: data.iddecinvproyecto ?? 0,
            iddecinvproyectotesista: data.iddecinvproyectotesista ?? 0,
            actividad: data.actividad ?? '',
            fechainicio: new Date(inicio) ?? fechaHoy,
            fechafin: new Date(fin) ?? new Date(),
            resultados: data.resultados ?? '',
            porcentajeparcial1: data.porcentajeparcial1 ?? 0,
            porcentajeparcial2: data.porcentajeparcial2 ?? 0,
            archivoevidencia1: data.archivoevidencia1 ?? '',
            archivoevidencia2: data.archivoevidencia2 ?? '',
            fechaevidencia1: data.fechaevidencia1 ?? new Date(),
            fechaevidencia2: data.fechaevidencia2 ?? new Date(),
            presencial: data.presentcial ?? 0,
        }
    )
}

export function setListProyectoTesistaCronograma(data: Array<any>): Array<TblDecInvProyectoTesistaCronograma> {
    let listProductoColaborador: Array<TblDecInvProyectoTesistaCronograma> = [];
    data.forEach((item) => {
        const productoColaboradorDTO: TblDecInvProyectoTesistaCronograma = SetTblDecInvProyectoTesistaCronograma(item)
        listProductoColaborador.push(productoColaboradorDTO);
    });
    return listProductoColaborador;
}